import config from '../../config';

export const travelPaths = {
  base: 'travel',
};

export const geonameMapPath = ({ slug, geonameId }: { slug: string; geonameId: string }) =>
  `${config.surflineHost}/${travelPaths.base}/${slug}-surfing-and-beaches/${geonameId}`;
